import jsQR from "jsqr";

import { extractOtpauthSecret } from "./common";

async function fileToImageData(file: File): Promise<ImageData> {
  let bitmap: ImageBitmap;
  try {
    bitmap = await createImageBitmap(file);
  } catch {
    throw new Error("That file is not a valid image.");
  }
  try {
    const canvas = document.createElement("canvas");
    canvas.width = bitmap.width;
    canvas.height = bitmap.height;
    const ctx = canvas.getContext("2d");
    if (!ctx) {
      throw new Error("Could not process the image.");
    }
    ctx.drawImage(bitmap, 0, 0);
    return ctx.getImageData(0, 0, canvas.width, canvas.height);
  } finally {
    bitmap.close();
  }
}

// Decode an image file, find a QR code, and return the authenticator secret.
// Throws with a human-readable message when the image has no QR code, the QR
// code is not an otpauth URI, or the URI carries no secret.
export async function decodeQrSecret(file: File): Promise<string> {
  const imageData = await fileToImageData(file);
  const result = jsQR(imageData.data, imageData.width, imageData.height);

  if (!result) {
    throw new Error("Could not read a QR code from that image.");
  }
  if (!result.data.startsWith("otpauth://")) {
    throw new Error("That QR code is not an authenticator (otpauth) QR code.");
  }

  const secret = extractOtpauthSecret(result.data);
  if (!secret) {
    throw new Error("That QR code has no authenticator secret.");
  }

  return secret;
}
